import { render } from "./AlimtalkMigrationCard.vue?vue&type=template&id=06c70e77&scoped=true"
import script from "./AlimtalkMigrationCard.vue?vue&type=script&lang=js"
export * from "./AlimtalkMigrationCard.vue?vue&type=script&lang=js"

import "./AlimtalkMigrationCard.vue?vue&type=style&index=0&id=06c70e77&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c70e77"]])

export default __exports__